import React, { useState } from 'react';
import { X, Calendar, Clock } from 'lucide-react';

const SchedulingModal = ({ onClose, onSubmit }) => {
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');

    const handleSubmit = () => {
        if (!date || !time) {
            alert('Por favor, selecione uma data e um horário.');
            return;
        }
        const scheduledAt = new Date(`${date}T${time}`);
        onSubmit(scheduledAt);
    };

    const getTodayString = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const day = today.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl w-full max-w-sm relative animate-slide-up flex flex-col" onClick={(e) => e.stopPropagation()}>
                <header className="p-4 border-b flex justify-between items-center">
                    <h2 className="text-xl font-bold text-gray-800">Agendar Serviço</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200">
                        <X className="w-5 h-5" />
                    </button>
                </header>

                <main className="p-6 space-y-4">
                    <div>
                        <label htmlFor="schedule-date" className="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                            <Calendar className="w-4 h-4 mr-2 text-gray-500" />
                            Data do Serviço
                        </label>
                        <input
                            type="date"
                            id="schedule-date"
                            name="schedule-date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            min={getTodayString()} // Impede a seleção de datas passadas
                            className="w-full p-3 border rounded-lg bg-gray-50"
                        />
                    </div>
                    <div>
                        <label htmlFor="schedule-time" className="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                            <Clock className="w-4 h-4 mr-2 text-gray-500" />
                            Horário
                        </label>
                        <input
                            type="time"
                            id="schedule-time"
                            name="schedule-time"
                            value={time}
                            onChange={(e) => setTime(e.target.value)}
                            className="w-full p-3 border rounded-lg bg-gray-50"
                        />
                    </div>
                </main>

                <footer className="p-4 bg-gray-50 border-t">
                    <button
                        onClick={handleSubmit}
                        className="w-full py-3 bg-green-600 text-white font-bold rounded-xl flex items-center justify-center hover:bg-green-700 transition">
                        Confirmar Agendamento
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default SchedulingModal;
